






























































import BaseComponent from '@/components/base-component.vue';
import UiAutocompleClientsSubsidiaries from '@/components/UI/autocomplete-clients-subsidiaries.vue';
import UiDatePickerRange from '@/components/UI/date-picker-range.vue';
import ListMessages from '@/components/UI/list-messages.vue';
import PermissionAuth from '@/components/UI/permission-auth.vue';
import UiSelectClients from '@/components/UI/select-clients.vue';
import UiSelectDoctor from '@/components/UI/select-doctors.vue';
import { PrescricaoEnderecoRelatorioFiltroDTO } from '@/interfaces/address-prescriptions-report';
import { PaginationSyncDTO } from '@/interfaces/base-dto';
import * as service from '@/services/address-prescriptions-report';
import { BehaviorSubject } from 'rxjs';
import { debounceTime, skipWhile, switchMap, tap } from 'rxjs/operators';
import Component from 'vue-class-component';
import { Watch } from 'vue-property-decorator';

@Component({
  components: {
    PermissionAuth,
    ListMessages,
    UiAutocompleClientsSubsidiaries,
    UiSelectClients,
    UiDatePickerRange,
    UiSelectDoctor
  }
})
export default class AddressPrescriptionsReport extends BaseComponent {
  filter: any = {
  };

  error = false;
  loading = false;
  loadingXls = false;
  executed = false;

  items: any = [];
  pagination: PaginationSyncDTO = new PaginationSyncDTO();

  public $refs!: {
    form: HTMLFormElement;
  };

  public form: any = {
    valid: false,
    rules: {
      periodo: [(v) => !!v || 'Escolha um período']
    }
  };

  headersIni = [
    { text: 'Empresa', value: 'nmEmpresa', sortable: true },
    { text: 'Tipo bolsa', value: 'tipoBolsa', sortable: true, align: 'center' },
    { text: 'Cliente', value: 'cdCliente', sortable: true },
    { text: 'Unidade', value: 'nmUnidadeCliente', sortable: true },
    { text: 'Descrição endereço', value: 'descricaoEndereco', sortable: true },
    { text: 'Logradouro', value: 'logradouro', sortable: true },
    { text: 'Bairro', value: 'bairro', sortable: true },
    { text: 'Município', value: 'municipio', sortable: true },
    { text: 'UF', value: 'uf', sortable: true },
  ];

  headers = [];

  private execBehaviorSub$: BehaviorSubject<any> = new BehaviorSubject(null);

  mounted() {
    this.execBehaviorSub$
      .pipe(
        skipWhile((val) => {
          return val === null;
        }),
        debounceTime(300),
        tap(() => {
          this.loading = true;
        }),
        switchMap((filter) => {
          return service.listDataAddressPrescriptionsReport(filter);
        })
      )
      .subscribe(
        (res) => {
          this.items = res.content;
          PaginationSyncDTO.update(this.pagination, res);
          this.loading = false;
          this.executed = true;
          this.headers = Object.assign([], this.headersIni);
          this.addHeaders();
        },
        (error) => {
          this.loading = false;
          this.error = true;
          this.execBehaviorSub$.next(null);
        }
      );
  }

  addHeaders() {
    if (!this.items || !this.items || !this.items.length) {
      return;
    }
    this.items[0].dias.forEach((i) => {
      this.headers.push({ text: i.titulo, value: i.nome, sortable: true, align: 'center' });
    });
  }

  public exec(changePage: boolean = false) {
    if (!changePage) {
      this.pagination.page = 1;
    }
    this.$refs.form.validate();
    if (!this.form.valid) {
      return;
    }
    this.executed = false;
    this.loading = true;
    this.error = false;

    let parm = this.buildFilterParm();
    this.execBehaviorSub$.next(parm);
  }

  private buildFilterParm() {
    let parm = new PrescricaoEnderecoRelatorioFiltroDTO();
    let filter = this.filter;

    parm.dataIni = filter.periodo && filter.periodo.length > 0 ? filter.periodo[0] : null;
    parm.dataFim = filter.periodo && filter.periodo.length > 1 ? filter.periodo[1] : null;
    parm.update(this.pagination);

    return parm;
  }

  public exportXls() {
    this.loader.start('Gerando XLS...');
    this.loadingXls = true;
    let parm = this.buildFilterParm();

    service.buildAddressPrescriptionsXlsReport(parm).subscribe(
      (res) => {
        this.loader.stop();
        this.loadingXls = false;
        this.forceFileAxiosResponseDownload(res, 'relatorio.xls');
      },
      (error) => {
        this.loader.stop();
        this.loadingXls = false;
        this.showToastApiError(error);
      }
    );
  }

  @Watch('pagination.page')
  private onChangePage(val) {
    this.exec(true);
  }

  @Watch('pagination.sortBy')
  @Watch('pagination.descending')
  @Watch('pagination.rowsPerPage')
  private onChangeSort(val) {
    this.exec(false);
  }

  getTitle() {
    return 'Relatório de Prescrições por Endereço';
  }
}
